import { createAsyncThunk } from '@reduxjs/toolkit';
import { setPaymentGatewayTokens } from '../reducers/paymentGatewayTokens';
import Api, { FetchParams, AuthenticationMethod } from '../utils/Api';
import processPaymentGatewayToken from '../utils/processors/processPaymentGatewayToken';
import { getMember, getGatewayType } from '../selectors';
import { PAYMENT_GATEWAY_TYPES } from '../constants';

export const fetchPaymentGatewayTokens = createAsyncThunk(
  '$fetchPaymentGatewayTokens',
  async (
    data: {
      authenticationMethod?: AuthenticationMethod;
    },
    { dispatch, rejectWithValue, getState },
  ) => {
    const member = getMember(getState() as EntireFrontendState);
    const gatewayType = getGatewayType(getState() as EntireFrontendState);
    const { authenticationMethod = member ? 'member' : 'none' } = data;

    try {
      const isRedcatPay = gatewayType === PAYMENT_GATEWAY_TYPES.REDCAT_PAY;

      const params: FetchParams = {
        path: isRedcatPay
          ? '/api/v2/online-payments/cards'
          : '/api/v1/profile/pgtokens',
        method: 'GET',
      };

      const response = await Api.fetch(params, authenticationMethod);

      const rawTokens: RawPaymentGatewayToken[] = response.data;

      const processedTokens = rawTokens.map(processPaymentGatewayToken);

      dispatch(setPaymentGatewayTokens(processedTokens));
    } catch (e) {
      console.warn('Fetch payment gateway tokens failed', { e });
      return rejectWithValue(e);
    }
  },
  {
    // Both token endpoints are member-only, so an unauthenticated request can only 403
    // (e.g. guest ordering, or before checkAuthToken has set the member).
    condition: ({ authenticationMethod }, { getState }) =>
      authenticationMethod
        ? authenticationMethod !== 'none'
        : !!getMember(getState() as EntireFrontendState),
  },
);
